import React, { Component } from 'react';
import { Formik, Form, Field } from 'formik';
import { Button, Grid, Divider, Message } from 'semantic-ui-react'
import { Link } from 'react-router-dom';
import _ from 'lodash';

import FormsInputsSingleCheckbox from '../../../inputs/singlecheckbox';

const getValueForRoleName = (roleName, assignedRoles) => {
    if (!assignedRoles) { return false; }
    const selectedRole = _.find(assignedRoles, (role) => role.type === roleName);
    if (!selectedRole) { return false; }
    return true;
}

class FormsHradminEmployeeUpdateAccessForm extends Component {
    state = {
        error: false,
        errorMessage: null,
        success: false
    }
    renderClaimSubmissionResult() {
        if (this.state.success === true) {
            return (
                <Message positive>
                    <Message.Header>
                        Access Updated Successfully!
                    </Message.Header>
                    <p>
                        Click <Link to="/hradmin/employees">here</Link> to view employee list and update view data.
                    </p>
                </Message>
            );
        }
        if (this.state.error === true) {
            return (
                <Message negative>
                    <Message.Header>We're sorry - there was an issue with the claim</Message.Header>
                    <p>
                        { this.state.errorMessage }
                    </p>
                </Message>
            );
        }
    }
    render() {
        return (
            <Formik
                initialValues={{ 
                    client: true,
                    hradmin: getValueForRoleName('hradmin', this.props.selectedUserRole),
                }}
                onSubmit={(values, actions) => {
                    // console.log(values, actions);
                    // this.props.updateSearchParameters(values.searchType, values.searchText);
                    // actions.setSubmitting(false);
                    this.props.submitHradminEmployeeUpdateAccess({
                        data: values,
                        userId: this.props.targetUuid,
                        accessToken: this.props.user.accessToken,
                    }, (result, error) => {
                        // console.log(result, error);
                        // console.log(result, error, 'done');
                        if (error) {
                            console.log('done-failed');
                            actions.setSubmitting(false);
                            this.setState({error: true, success: false, errorMessage: error.message});
                        }
                        if (result) {
                            console.log('done-success');
                            this.setState({error: false, success: true, errorMessage: null});
                        }
                    })
                }}
                render={({
                    values,
                    errors,
                    status,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                }) => (
                    <Form>
                        <Grid columns={2}>
                            <Grid.Column width={16}>
                                <Divider horizontal>
                                    User Access Assignment
                                </Divider>
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name='client'
                                    label="Normal User Access"
                                    component={FormsInputsSingleCheckbox}
                                    disabled={true}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name='hradmin'
                                    label="HR Admin User Access"
                                    component={FormsInputsSingleCheckbox}
                                />
                            </Grid.Column>
                            <Grid.Column width={16}>
                                {this.renderClaimSubmissionResult()}
                            </Grid.Column>
                            <Grid.Column width={16}>
                                <Button 
                                    loading={isSubmitting}
                                    type="submit" 
                                    primary 
                                    disabled={isSubmitting}
                                    fluid
                                >
                                Update User Access
                            </Button>
                        </Grid.Column>
                        </Grid>
                    </Form>
                )}
            />
        );
    }
}

export default FormsHradminEmployeeUpdateAccessForm;